export const ASSIGN_ERROR_FALLBACK_MESSAGE = 'Failed to assign shift.';

// Build the assign/fill error line shown in the modal. The detail (`errorField`)
// is only appended when present — otherwise we show the message alone, never a
// trailing ": Unknown error" placeholder.
export function formatAssignErrorLine(
    errorMessage: string | null,
    errorField: string | null,
): string {
    const base = errorMessage ?? ASSIGN_ERROR_FALLBACK_MESSAGE;
    return errorField ? `${base}: ${errorField}` : base;
}
